
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/verify-email",
      function () {
        return require("private-next-pages/verify-email/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/verify-email"])
      });
    }
  